import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import {
  renderTextField,
  renderCheckbox,
  renderSelectField,
  renderDatePicker,
  renderAutoComplete
} from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
import Menu from 'material-ui/Menu';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import ActionFace from 'material-ui/svg-icons/action/face';
import ActionLaunch from 'material-ui/svg-icons/action/launch';

import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import ContentClear from 'material-ui/svg-icons/content/clear';

var jsonpatch = require('fast-json-patch')

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  pt15: {
    paddingTop: 15,
  },
  m15: {
    marginTop: 15,
  },
};

var dontHaveGroupRegFee = true;
var identifier;
var length = 0; //Autocomplete

class TgroupForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openPopover: false
    }
  }

  handlePopoverClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      openPopover: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestPopoverClose = () => {
    this.setState({
      openPopover: false,
    });
  }

  componentWillMount() {
    if (typeof this.props.groupregistrationfee === 'undefined') {
      dontHaveGroupRegFee = true;
    }
  }

  componentDidMount() {
    if (typeof this.props.groupinfos !== 'undefined' && this.props.groupinfos.type === "unset") {
      if (typeof this.props.tracker.values.type !== 'undefined' && this.props.tracker.values.type === '') {
        this.props.change("type", "pszichodráma asszisztensi")
      }
    }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  renderStartDate() {
    if (typeof this.props.groupinfos.startDate !== 'undefined') {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.startDate !== 'undefined' ?
                  this.props.tracker.values.startDate === null ? 'deleted dateInput'
                  : 'ac1 dateInput'
                : 'ac2 dateInput'
              : 'ac3 dateInput'
            : 'ac4 dateInput'
          }
          component={renderDatePicker}
          label="Kezdés dátuma"
          floatingLabelText="Kezdés dátuma"
          hintText="Kezdés dátuma"
          type="text"
          style={{width: 120}}
          defaultDate={new Date(this.props.groupinfos.startDate)}
          name="startDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="startDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.startDate !== 'undefined' ?
                this.props.tracker.values.startDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("startDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    } else {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.startDate !== 'undefined' ?
                  this.props.tracker.values.startDate === null ? 'deleted dateInput'
                  : 'ac11 dateInput'
                : 'ac21 dateInput'
              : 'ac31 dateInput'
            : 'ac41 dateInput'
          }
          component={renderDatePicker}
          label="Kezdés dátuma"
          floatingLabelText="Kezdés dátuma"
          hintText="Kezdés dátuma"
          type="text"
          style={{width: 120}}
          name="startDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="startDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.startDate !== 'undefined' ?
                this.props.tracker.values.startDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("startDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    }
  }

  renderEndDate() {
    if (typeof this.props.groupinfos.endDate !== 'undefined') {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.endDate !== 'undefined' ?
                  this.props.tracker.values.endDate === null ? 'deleted dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            : 'ac dateInput'
          }
          component={renderDatePicker}
          label="Befejezés dátuma"
          floatingLabelText="Befejezés dátuma"
          hintText="Befejezés dátuma"
          type="text"
          style={{width: 120}}
          defaultDate={new Date(this.props.groupinfos.endDate)}
          name="endDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="endDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.endDate !== 'undefined' ?
                this.props.tracker.values.endDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("endDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    } else {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.endDate !== 'undefined' ?
                  this.props.tracker.values.endDate === null ? 'deleted dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            : 'ac dateInput'
          }
          component={renderDatePicker}
          label="Befejezés dátuma"
          floatingLabelText="Befejezés dátuma"
          hintText="Befejezés dátuma"
          type="text"
          style={{width: 120}}
          name="endDate" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="endDate"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.endDate !== 'undefined' ?
                this.props.tracker.values.endDate !== null ? (<div className="">
                    <IconButton onClick={this.delete("endDate")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    }
  }

  renderExam() {
    if (typeof this.props.groupinfos.exam !== 'undefined') {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.exam !== 'undefined' ?
                  this.props.tracker.values.exam === null ? 'deleted dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            : 'ac dateInput'
          }
          component={renderDatePicker}
          label="Vizsga időpontja"
          floatingLabelText="Vizsga időpontja"
          hintText="Vizsga időpontja"
          type="text"
          style={{width: 120}}
          defaultDate={new Date(this.props.groupinfos.exam)}
          name="exam" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="exam"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.exam !== 'undefined' ?
                this.props.tracker.values.exam !== null ? (<div className="">
                    <IconButton onClick={this.delete("exam")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    } else {
      return <div>
        <Field
          className={
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.exam !== 'undefined' ?
                  this.props.tracker.values.exam === null ? 'deleted dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            : 'ac dateInput'
          }
          component={renderDatePicker}
          label="Vizsga időpontja"
          floatingLabelText="Vizsga időpontja"
          hintText="Vizsga időpontja"
          type="text"
          style={{width: 120}}
          name="exam" />
        <Field
          component={renderTextField}
          className="dateText"
          floatingLabelText=""
          name="exam"
          type="text"
        />
        {
          typeof this.props.tracker !== 'undefined' ?
            typeof this.props.tracker.values !== 'undefined' ?
              typeof this.props.tracker.values.exam !== 'undefined' ?
                this.props.tracker.values.exam !== null ? (<div className="">
                    <IconButton onClick={this.delete("exam")} className="deleteIcon">
                      <ContentClear />
                    </IconButton>
                  </div>)
                : void(0)
              : void(0)
            : void(0)
          : void(0)
        }
      </div>
    }
  }

  /**
    * Autocomplete handler
    *   - handleGroupSupervisor
    *   - handleGroupLeader
    *   - handleParticipants
    *   - handleParticipantsLeaderPartner
    *   - handleParticipantsSupervisor
    *   - handleParticipantsGroupSupervisor
    * auto input setting from Autocomplete value
    * 
  **/
  handleGroupSupervisor = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      this.props.change('groupSupervisor.name', items[0].trim())
      this.props.change('groupSupervisor.id', items[3].trim())
      this.props.change('newgroupSupervisor.name', '')
  }
  handleGroupLeader0 = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      items.forEach( function(item, index) {
        if (typeof item == 'undefined' || item.trim() == "undefined") {
          items[index] = ''
        }
      })
      this.props.change('leaders.[0].name', items[0].trim())
      //this.props.change('leaders.[0].email', items[1].trim())
      //this.props.change('leaders.[0].tbNumber', items[2].trim())
      this.props.change('leaders.[0].id', items[3].trim())
      this.props.change('newLeader0.name', null)
  }
  handleGroupLeader1 = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      items.forEach( function(item, index) {
        if (typeof item == 'undefined' || item.trim() == "undefined") {
          items[index] = ''
        }
      })
      this.props.change('leaders.[1].name', items[0].trim())
      //this.props.change('leaders.[1].email', items[1].trim())
      //this.props.change('leaders.[1].tbNumber', items[2].trim())
      this.props.change('leaders.[1].id', items[3].trim())
      this.props.change('newLeader1.name', null)
  }
  handleParticipants = (selectedItem) => {
    let items = selectedItem.value.props.value.split("|")
    items.forEach( function(item, index) {
      if (typeof item == 'undefined' || item.trim() == "undefined") {
        items[index] = ''
      }
    })
    if (items[0].trim() !== '') {
      this.props.change('participants.['+this.props.tracker.values.participants.length+'].name', items[0].trim())
    }
    if (items[1].trim() !== '') {
      this.props.change('participants.['+(this.props.tracker.values.participants.length - 1)+'].email', items[1].trim())
    }
    if (items[2].trim() !== '') {
      this.props.change('participants.['+(this.props.tracker.values.participants.length - 1)+'].tbNumber', items[2].trim())
    }
    if (items[3].trim() !== '') {
      this.props.change('participants.['+(this.props.tracker.values.participants.length - 1)+'].id', items[3].trim())
    }
    this.props.change('participants.new.name', null)
  }
  handleParticipantsLeaderPartner = (selectedItem) => {
    let items = selectedItem.value.props.value.split("|")
    items.forEach( function(item, index) {
      if (typeof item == 'undefined' || item.trim() == "undefined") {
        items[index] = ''
      }
    })
    if (items[0].trim() !== '') {
      this.props.change('participants.['+identifier+'].leaderPartner.name', items[0].trim())
    }
    if (items[1].trim() !== '') {
      this.props.change('participants.['+identifier+'].leaderPartner.email', items[1].trim())
    }
    if (items[2].trim() !== '') {
      this.props.change('participants.['+identifier+'].leaderPartner.tbNumber', items[2].trim())
    }
    if (items[3].trim() !== '') {
      this.props.change('participants.['+identifier+'].leaderPartner.id', items[3].trim())
    }
    if (items[4].trim() !== '') {
      this.props.change('participants.['+identifier+'].leaderPartner.birthday', items[4].trim())
    }
    if (items[5].trim() !== '') {
      this.props.change('participants.['+identifier+'].leaderPartner.indexNumber', items[5].trim())
    }
    this.props.change('participants.['+identifier+'].newLeaderPartner.name', null)
  }
  handleParticipantsSupervisor = (selectedItem) => {
    let items = selectedItem.value.props.value.split("|")
    items.forEach( function(item, index) {
      if (typeof item == 'undefined' || item.trim() == "undefined") {
        items[index] = ''
      }
    })
    if (items[0].trim() !== '') {
      this.props.change('participants.['+identifier+'].supervisor.name', items[0].trim())
    }
    if (items[1].trim() !== '') {
      this.props.change('participants.['+identifier+'].supervisor.email', items[1].trim())
    }
    if (items[2].trim() !== '') {
      this.props.change('participants.['+identifier+'].supervisor.tbNumber', items[2].trim())
    }
    if (items[3].trim() !== '') {
      this.props.change('participants.['+identifier+'].supervisor.id', items[3].trim())
    }
    if (items[4].trim() !== '') {
      this.props.change('participants.['+identifier+'].supervisor.birthday', items[4].trim())
    }
    if (items[5].trim() !== '') {
      this.props.change('participants.['+identifier+'].supervisor.indexNumber', items[5].trim())
    }
    this.props.change('participants.['+identifier+'].newSupervisor.name', null)
  }
  handleParticipantsGroupSupervisor = (selectedItem) => {
    let items = selectedItem.value.props.value.split("|")
    items.forEach( function(item, index) {
      if (typeof item == 'undefined' || item.trim() == "undefined") {
        items[index] = ''
      }
    })
    if (items[0].trim() !== '') {
      this.props.change('participants.['+identifier+'].groupSupervisor.name', items[0].trim())
    }
    if (items[1].trim() !== '') {
      this.props.change('participants.['+identifier+'].groupSupervisor.email', items[1].trim())
    }
    if (items[2].trim() !== '') {
      this.props.change('participants.['+identifier+'].groupSupervisor.tbNumber', items[2].trim())
    }
    if (items[3].trim() !== '') {
      this.props.change('participants.['+identifier+'].groupSupervisor.id', items[3].trim())
    }
    if (items[4].trim() !== '') {
      this.props.change('participants.['+identifier+'].groupSupervisor.birthday', items[4].trim())
    }
    if (items[5].trim() !== '') {
      this.props.change('participants.['+identifier+'].groupSupervisor.indexNumber', items[5].trim())
    }
    this.props.change('participants.['+identifier+'].newGroupSupervisor.name', null)
  }
  

  componentWillUpdate() {
  }
  componentDidUpdate() {
  }
  /**
    * render blocks with Autocomplete
    * type: Group Leaders -> 0-2 with delete
    * type: Group Supervisor -> only one with delete
    * type: Group Participants
    *   - list without delete
    *   - auto create on autocomplete select
    *   - can open participant single
    *   - can have modules controlled by group type
    * Group Participant single in "Participants"
    *   - leaderPartner
    *   - supervisor
    *   - groupSupervisor
    * 
  **/
  renderBase(type) {
    var datasource = []
    let dataSourceConfig = {
      text: 'text',
      value: 'value',
    };
    // let length = 0;
    if (typeof this.props.autocomplete !== 'undefined') {
      datasource = [];
      this.props.autocomplete.map((option, index) => {
        datasource.push(
          {
            text: '',
            value: (
              <MenuItem key={index} value={option.name+' | '+option.email+' | '+option.tbNumber+' | '+option.id+' | '+option.birthday+' | '+option.indexNumber} primaryText={option.name} />
            ),
          },
        )
      })
    }

    const fetch = (target, querystring, autocomplete) => {
      this.props.fetchMessage(target, querystring, autocomplete)
    };
    if (type == "groupSupervisor") {
      if (typeof this.props.tracker !== 'undefined') {
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && document.activeElement.name == 'newgroupSupervisor.name' && length !== document.activeElement.value.length) {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
      return <Paper zDepth={0}>
        <div className="horizontal flexrow">
          {
            (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.groupSupervisor !== 'undefined') ? <IconButton
                        iconStyle={styles.smallIcon}
                        style={styles.m15}
                        href={"/persons/"+this.props.tracker.values.groupSupervisor.id} target="_blank"
                      >
                        <ActionLaunch />
                      </IconButton>
            : void(0)
          }
          <Field
            className={"itsAWeirdAnInput"}
            disabled={true}
            component={renderTextField}
            label="csoport szupervízor"
            name="groupSupervisor.name"
            style={{width: 180}}
          >
          </Field>
          {
            (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.groupSupervisor !== 'undefined') ? <IconButton
                iconStyle={styles.smallIcon}
                style={styles.m15}
                onMouseDown={this.delete("groupSupervisor.name")}
              >
                <ActionDelete />
              </IconButton>
            : void(0)
          }
        </div>
        <Field
          className="hidden"
          style={{
            display: 'none'
          }}
          component={renderTextField}
          name="groupSupervisor.id"
          type="hidden"
        />
        <Field
          className="personAutocomplete plusItem"
          component={renderAutoComplete}
          label="szupervízor hozzáadása/cseréje"
          name="newgroupSupervisor.name"
          dataSource={datasource}
          dataSourceConfig={dataSourceConfig}
          onNewRequest={this.handleGroupSupervisor}
        >
        </Field>
      </Paper>
    } else if (type == "leaders") {
      if (typeof this.props.tracker !== 'undefined') {
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && document.activeElement.name.substring(0,9) == 'newLeader' && length !== document.activeElement.value.length) {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
      let count = 0;
      if (typeof this.props.tracker !== 'undefined') {
        return <div>
          <Paper zDepth={0}>
            <div className="horizontal flexrow">
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[0] !== 'undefined' && this.props.tracker.values.leaders[0] !== null) ? <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.m15}
                            href={"/persons/"+this.props.tracker.values.leaders[0].id} target="_blank"
                          >
                            <ActionLaunch />
                          </IconButton>
                : void(0)
              }
              <Field
                className={"itsAWeirdAnInput"}
                disabled={true}
                component={renderTextField}
                label="1. csoportvezető"
                name="leaders.[0].name"
                style={{width: 180}}
              >
              </Field>
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[0] !== 'undefined' && this.props.tracker.values.leaders[0] !== null && typeof this.props.tracker.values.leaders[0].id !== 'undefined' && this.props.tracker.values.leaders[0].id !== null) ? <IconButton
                    iconStyle={styles.smallIcon}
                    style={styles.m15}
                    onMouseDown={this.delete("leaders.[0].name")}
                  >
                    <ActionDelete />
                  </IconButton>
                : void(0)
              }
            </div>
            <Field
              className="hidden"
              style={{
                display: 'none'
              }}
              component={renderTextField}
              name="leaders.[0].id"
              type="hidden"
            />
            <Field
              className="personAutocomplete plusItem"
              component={renderAutoComplete}
              label="1. csoportvezető hozzáadása"
              name="newLeader0.name"
              dataSource={datasource}
              dataSourceConfig={dataSourceConfig}
              onNewRequest={this.handleGroupLeader0}
            >
            </Field>
          </Paper>
          <Paper zDepth={0}>
            <div className="horizontal flexrow">
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[1] !== 'undefined' && this.props.tracker.values.leaders[1] !== null && typeof this.props.tracker.values.leaders[1].id !== 'undefined' && this.props.tracker.values.leaders[1].id !== null) ? <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.m15}
                            href={"/persons/"+this.props.tracker.values.leaders[1].id} target="_blank"
                          >
                            <ActionLaunch />
                          </IconButton>
                : void(0)
              }
              <Field
                className={"itsAWeirdAnInput"}
                disabled={true}
                component={renderTextField}
                label="2. csoportvezető"
                name="leaders.[1].name"
                style={{width: 180}}
              >
              </Field>
              {
                (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.leaders !== 'undefined' && typeof this.props.tracker.values.leaders[1] !== 'undefined' && this.props.tracker.values.leaders[1] !== null) ? <IconButton
                    iconStyle={styles.smallIcon}
                    style={styles.m15}
                    onMouseDown={this.delete("leaders.[1].name")}
                  >
                    <ActionDelete />
                  </IconButton>
                : void(0)
              }
            </div>
            <Field
              className="hidden"
              style={{
                display: 'none'
              }}
              component={renderTextField}
              name="leaders.[1].id"
              type="hidden"
            />
            <Field
              className="personAutocomplete plusItem"
              component={renderAutoComplete}
              label="2. csoportvezető hozzáadása"
              name="newLeader1.name"
              dataSource={datasource}
              dataSourceConfig={dataSourceConfig}
              onNewRequest={this.handleGroupLeader1}
            >
            </Field>
          </Paper>
        </div>
      }
    } else if (type == "participants") {
      if (typeof this.props.tracker !== 'undefined') {
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && document.activeElement.name == 'participants.new.name' && length !== document.activeElement.value.length) {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && document.activeElement.name.indexOf('newLeaderPartner.name') > -1 && length !== document.activeElement.value.length) {
            // participants.["+index+"].newLeaderPartner.name
            identifier = parseInt( document.activeElement.name.substring( (document.activeElement.name.indexOf('[') + 1) , document.activeElement.name.indexOf(']') ) )
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && document.activeElement.name.indexOf('newSupervisor.name') > -1 && length !== document.activeElement.value.length) {
            // participants.["+index+"].newLeaderPartner.name
            identifier = parseInt( document.activeElement.name.substring( (document.activeElement.name.indexOf('[') + 1) , document.activeElement.name.indexOf(']') ) )
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && document.activeElement.name.indexOf('newGroupSupervisor.name') > -1 && length !== document.activeElement.value.length) {
            // participants.["+index+"].newLeaderPartner.name
            identifier = parseInt( document.activeElement.name.substring( (document.activeElement.name.indexOf('[') + 1) , document.activeElement.name.indexOf(']') ) )
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete4')
            window.removeEventListener("keyup", getAutoComplete);
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
      let count = 0;
      if (typeof this.props.tracker.values !== 'undefined' && typeof this.props.tracker.values.participants !== 'undefined') {
        let modules = [];
        switch (this.props.tracker.values.type) {
          case 'pszichodráma asszisztensi':
            modules = ['képzési', 'vizsga', 'tanúsítvány']
            break;
          case 'pszichodráma felsőfok':
            modules = ['képzési', 'vizsga', 'tanúsítvány', 'vezető képzés', 'workshop']
            break;
          case 'bibliodráma asszisztensi':
            modules = ['képzési', 'vizsga', 'tanúsítvány', 'workshop']
            break;
          case 'bibliodráma felsőfok':
            modules = ['képzési', 'vizsga', 'tanúsítvány', 'vezető képzés', 'workshop']
            break;
          case 'gyermekdráma asszisztensi':
            modules = ['képzési', 'vizsga', 'tanúsítvány']
            break;
          case 'gyermekdráma felsőfok':
            modules = ['képzési', 'vizsga', 'tanúsítvány', 'vezető képzés', 'workshop']
            break;
          default: 
            modules = [];
        }
        return <div>
            <Field
              className="personAutocomplete plusItem"
              component={renderAutoComplete}
              label="Új résztvevő"
              name={"participants.new.name"}
              dataSource={datasource}
              dataSourceConfig={dataSourceConfig}
              onNewRequest={this.handleParticipants}
            >
            </Field>
          {
            this.props.tracker.values.participants.map((option, index) => {
              let email;
              if (typeof option.email !== "undefined") {
                if (option.email.length > 0) {
                  email = <span>
                    <span style={{color: darkBlack}}>Email:</span>
                    <span> {option.email} </span>
                  </span>
                }
              }
              let birthday;
              if (typeof option.birthday !== "undefined") {
                if (option.birthday.length > 0) {
                  birthday = <span>
                    <span style={{color: darkBlack}}>Született:</span>
                    <span> {option.birthday} </span>
                  </span>
                }
              }
              // registrationFee
                let paymentDate;
                if (typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' && typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined') {
                  paymentDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.paymentDate === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="befizetés időpontja"
                      floatingLabelText="befizetés időpontja"
                      hintText="befizetés időpontja"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].registrationFee.paymentDate)}
                      name={"participants.["+index+"].registrationFee.paymentDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.paymentDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.paymentDate !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.paymentDate")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  paymentDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.paymentDate === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="befizetés időpontja"
                      floatingLabelText="befizetés időpontja"
                      hintText="befizetés időpontja"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].registrationFee.paymentDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.paymentDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.paymentDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.paymentDate !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.paymentDate")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let notice1;
                if (typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' && typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined') {
                  notice1 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice1 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="első felszólító levél"
                      floatingLabelText="első felszólító levél"
                      hintText="első felszólító levél"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].registrationFee.notice1)}
                      name={"participants.["+index+"].registrationFee.notice1"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice1"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice1 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice1")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  notice1 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice1 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="első felszólító levél"
                      floatingLabelText="első felszólító levél"
                      hintText="első felszólító levél"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].registrationFee.notice1"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice1"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice1 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice1 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice1")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let notice2;
                if (typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' && typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined') {
                  notice2 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice2 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="második felszólító levél"
                      floatingLabelText="második felszólító levél"
                      hintText="második felszólító levél"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].registrationFee.notice2)}
                      name={"participants.["+index+"].registrationFee.notice2"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice2"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice2 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice2")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  notice2 = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                                typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                  this.props.tracker.values.participants[index].registrationFee.notice2 === null ? 'deleted dateInput'
                                  : 'ac dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="második felszólító levél"
                      floatingLabelText="második felszólító levél"
                      hintText="második felszólító levél"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].registrationFee.notice2"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].registrationFee.notice2"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].registrationFee !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].registrationFee.notice2 !== 'undefined' ?
                                this.props.tracker.values.participants[index].registrationFee.notice2 !== null ? (<div className="">
                                    <IconButton onClick={this.delete("participants.["+index+"].registrationFee.notice2")} className="deleteIcon">
                                      <ContentClear />
                                    </IconButton>
                                  </div>)
                                : void(0)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let regFee = <Paper zDepth={1}>
                    <label>Regisztrációs díj</label>
                    <br />
                    <Field
                      component={renderTextField}
                      floatingLabelText="a díj teljes értéke (Ft)"
                      name={"participants.["+index+"].registrationFee.amount"}
                      type="text"/>
                    <Field
                      component={renderTextField}
                      floatingLabelText="befizetett összeg (Ft)"
                      name={"participants.["+index+"].registrationFee.payed"}
                      type="text"/>
                    {paymentDate}
                    {notice1}
                    {notice2}
                    <Field
                      component={renderCheckbox}
                      label="elengedve"
                      name={"participants.["+index+"].registrationFee.isRemissed"}
                      style={styles.checkbox}
                    />
                  </Paper>
              // kepzesi modul
                let kepzesi;
                if (modules.indexOf('képzési') > -1 /*.includes('képzési') */) {
                  kepzesi = <Paper zDepth={1}>
                    <label>Képzési modul</label>
                    <br />
                    <Field
                      component={renderSelectField}
                      floatingLabelText={"státusz:"}
                      name={"participants.["+index+"].status"}
                    >
                      {
                        this.props.trainingstatus.map((option, index) => {
                          return <MenuItem key={index} value={option} primaryText={option} />
                        })
                      }
                    </Field>
                    <Field
                      component={renderCheckbox}
                      label="felnőttképzési szerződés"
                      name={"participants.["+index+"].hasAdultTrainingContract"}
                      style={styles.checkbox}
                    />
                    <Field
                      component={renderCheckbox}
                      label="ajánlás"
                      name={"participants.["+index+"].hasRecommendation"}
                      style={styles.checkbox}
                    />
                    <Field
                      component={renderCheckbox}
                      label="index"
                      name={"participants.["+index+"].hasIndex"}
                      style={styles.checkbox}
                    />
                    <Field
                      component={renderCheckbox}
                      label="hiányzás"
                      name={"participants.["+index+"].hasAbsent"}
                      style={styles.checkbox}
                    />
                    <Field
                      component={renderTextField}
                      floatingLabelText="hiányzás megjegyzés"
                      name={"participants.["+index+"].absentComment"}
                      type="text"/>
                    <Field
                      component={renderCheckbox}
                      label="diploma"
                      name={"participants.["+index+"].hasDiploma"}
                      style={styles.checkbox}
                    />
                    <Field
                      component={renderCheckbox}
                      label="jelentkezési lap"
                      name={"participants.["+index+"].hasApplicationForm"}
                      style={styles.checkbox}
                    />
                  </Paper>
                }
              // vizsga modul
                let vizsga;
                let examApplication;
                if (typeof this.props.tracker.values.participants[index].examApplication !== 'undefined') {
                  examApplication = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].examApplication !== 'undefined' ?
                                this.props.tracker.values.participants[index].examApplication === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsgára jelentkezés dátuma"
                      floatingLabelText="vizsgára jelentkezés dátuma"
                      hintText="vizsgára jelentkezés dátuma"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].examApplication)}
                      name={"participants.["+index+"].examApplication"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].examApplication"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].examApplication !== 'undefined' ?
                              this.props.tracker.values.participants[index].examApplication !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].examApplication")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  examApplication = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].examApplication !== 'undefined' ?
                                this.props.tracker.values.participants[index].examApplication === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsgára jelentkezés dátuma"
                      floatingLabelText="vizsgára jelentkezés dátuma"
                      hintText="vizsgára jelentkezés dátuma"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].examApplication"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].examApplication"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].examApplication !== 'undefined' ?
                              this.props.tracker.values.participants[index].examApplication !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].examApplication")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let examAllowed;
                if (typeof this.props.tracker.values.participants[index].examAllowed !== 'undefined') {
                  examAllowed = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].examAllowed !== 'undefined' ?
                                this.props.tracker.values.participants[index].examAllowed === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsgára bocsátás"
                      floatingLabelText="vizsgára bocsátás"
                      hintText="vizsgára bocsátás"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].examAllowed)}
                      name={"participants.["+index+"].examAllowed"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].examAllowed"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].examAllowed !== 'undefined' ?
                              this.props.tracker.values.participants[index].examAllowed !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].examAllowed")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  examAllowed = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].examAllowed !== 'undefined' ?
                                this.props.tracker.values.participants[index].examAllowed === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsgára bocsátás"
                      floatingLabelText="vizsgára bocsátás"
                      hintText="vizsgára bocsátás"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].examAllowed"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].examAllowed"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].examAllowed !== 'undefined' ?
                              this.props.tracker.values.participants[index].examAllowed !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].examAllowed")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let exam;
                if (typeof this.props.tracker.values.participants[index].exam !== 'undefined') {
                  exam = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].exam !== 'undefined' ?
                                this.props.tracker.values.participants[index].exam === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsga dátuma"
                      floatingLabelText="vizsga dátuma"
                      hintText="vizsga dátuma"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].exam)}
                      name={"participants.["+index+"].exam"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].exam"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].exam !== 'undefined' ?
                              this.props.tracker.values.participants[index].exam !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].exam")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  exam = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].exam !== 'undefined' ?
                                this.props.tracker.values.participants[index].exam === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsga dátuma"
                      floatingLabelText="vizsga dátuma"
                      hintText="vizsga dátuma"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].exam"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].exam"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].exam !== 'undefined' ?
                              this.props.tracker.values.participants[index].exam !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].exam")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let examNotification;
                if (typeof this.props.tracker.values.participants[index].examNotification !== 'undefined') {
                  examNotification = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].examNotification !== 'undefined' ?
                                this.props.tracker.values.participants[index].examNotification === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsga bejelentés dátuma"
                      floatingLabelText="vizsga bejelentés dátuma"
                      hintText="vizsga bejelentés dátuma"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].examNotification)}
                      name={"participants.["+index+"].examNotification"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].examNotification"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].examNotification !== 'undefined' ?
                              this.props.tracker.values.participants[index].examNotification !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].examNotification")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  examNotification = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].examNotification !== 'undefined' ?
                                this.props.tracker.values.participants[index].examNotification === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="vizsga bejelentés dátuma"
                      floatingLabelText="vizsga bejelentés dátuma"
                      hintText="vizsga bejelentés dátuma"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].examNotification"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].examNotification"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].examNotification !== 'undefined' ?
                              this.props.tracker.values.participants[index].examNotification !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].examNotification")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                if (modules.indexOf('vizsga') /* .includes('vizsga') */) {
                  vizsga = <Paper zDepth={1}>
                    <label>Vizsga modul</label>
                    <br />
                    {examApplication}
                    {examAllowed}
                    <Field
                      component={renderTextField}
                      floatingLabelText="vizsgáztató"
                      name={"participants.["+index+"].examMaster"}
                      type="text"/>
                    {exam}
                    <Field
                      component={renderTextField}
                      floatingLabelText="vizsga megjegyzés"
                      name={"participants.["+index+"].examComment"}
                      type="text"/>
                    {examNotification}
                    <Field
                      component={renderCheckbox}
                      label="sikeres vizsga"
                      name={"participants.["+index+"].isExamSuccess"}
                      style={styles.checkbox}
                    />
                  </Paper>
                }
              // tanusitvany modul
                let tanusitvany;
                let certificateDate;
                if (typeof this.props.tracker.values.participants[index].certificateDate !== 'undefined') {
                  certificateDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].certificateDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].certificateDate === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="tanúsítvány dátuma"
                      floatingLabelText="tanúsítvány dátuma"
                      hintText="tanúsítvány dátuma"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].certificateDate)}
                      name={"participants.["+index+"].certificateDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].certificateDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].certificateDate !== 'undefined' ?
                              this.props.tracker.values.participants[index].certificateDate !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].certificateDate")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  certificateDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].certificateDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].certificateDate === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="tanúsítvány dátuma"
                      floatingLabelText="tanúsítvány dátuma"
                      hintText="tanúsítvány dátuma"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].certificateDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].certificateDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].certificateDate !== 'undefined' ?
                              this.props.tracker.values.participants[index].certificateDate !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].certificateDate")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let certificateNotification;
                if (typeof this.props.tracker.values.participants[index].certificateNotification !== 'undefined') {
                  certificateNotification = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].certificateNotification !== 'undefined' ?
                                this.props.tracker.values.participants[index].certificateNotification === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="értesítés dátuma"
                      floatingLabelText="értesítés dátuma"
                      hintText="értesítés dátuma"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].certificateNotification)}
                      name={"participants.["+index+"].certificateNotification"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].certificateNotification"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].certificateNotification !== 'undefined' ?
                              this.props.tracker.values.participants[index].certificateNotification !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].certificateNotification")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  certificateNotification = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].certificateNotification !== 'undefined' ?
                                this.props.tracker.values.participants[index].certificateNotification === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="értesítés dátuma"
                      floatingLabelText="értesítés dátuma"
                      hintText="értesítés dátuma"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].certificateNotification"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].certificateNotification"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].certificateNotification !== 'undefined' ?
                              this.props.tracker.values.participants[index].certificateNotification !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].certificateNotification")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let certificateReceived;
                if (typeof this.props.tracker.values.participants[index].certificateReceived !== 'undefined') {
                  certificateReceived = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].certificateReceived !== 'undefined' ?
                                this.props.tracker.values.participants[index].certificateReceived === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="átvétel dátuma"
                      floatingLabelText="átvétel dátuma"
                      hintText="átvétel dátuma"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].certificateReceived)}
                      name={"participants.["+index+"].certificateReceived"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].certificateReceived"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].certificateReceived !== 'undefined' ?
                              this.props.tracker.values.participants[index].certificateReceived !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].certificateReceived")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  certificateReceived = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].certificateReceived !== 'undefined' ?
                                this.props.tracker.values.participants[index].certificateReceived === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="átvétel dátuma"
                      floatingLabelText="átvétel dátuma"
                      hintText="átvétel dátuma"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].certificateReceived"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].certificateReceived"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].certificateReceived !== 'undefined' ?
                              this.props.tracker.values.participants[index].certificateReceived !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].certificateReceived")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                if (modules.indexOf('tanúsítvány') > -1 /*.includes('tanúsítvány')*/) {
                  tanusitvany = <Paper zDepth={1}>
                    <label>Tanúsítvány modul</label>
                    <br />
                    <Field
                      component={renderTextField}
                      floatingLabelText="tanúsítvány száma"
                      name={"participants.["+index+"].certificateNumber"}
                      type="text"/>
                    {certificateDate}
                    {certificateNotification}
                    {certificateReceived}
                    <Field
                      component={renderTextField}
                      floatingLabelText="oklevél sorszáma"
                      name={"participants.["+index+"].certificateDiplomaNumber"}
                      type="text"/>
                  </Paper>
                }
              // vezeto modul
                let vezeto;
                let routineGroupStartDate
                if (typeof this.props.tracker.values.participants[index].routineGroupStartDate !== 'undefined') {
                  routineGroupStartDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].routineGroupStartDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].routineGroupStartDate === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="gyakorló csoport kezdés"
                      floatingLabelText="gyakorló csoport kezdés"
                      hintText="gyakorló csoport kezdés"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].routineGroupStartDate)}
                      name={"participants.["+index+"].routineGroupStartDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].routineGroupStartDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].routineGroupStartDate !== 'undefined' ?
                              this.props.tracker.values.participants[index].routineGroupStartDate !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].routineGroupStartDate")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  routineGroupStartDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].routineGroupStartDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].routineGroupStartDate === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="gyakorló csoport kezdés"
                      floatingLabelText="gyakorló csoport kezdés"
                      hintText="gyakorló csoport kezdés"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].routineGroupStartDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].routineGroupStartDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].routineGroupStartDate !== 'undefined' ?
                              this.props.tracker.values.participants[index].routineGroupStartDate !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].routineGroupStartDate")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                let routineGroupEndDate
                if (typeof this.props.tracker.values.participants[index].routineGroupEndDate !== 'undefined') {
                  routineGroupEndDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].routineGroupEndDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].routineGroupEndDate === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="gyakorló csoport befejezés"
                      floatingLabelText="gyakorló csoport befejezés"
                      hintText="gyakorló csoport befejezés"
                      type="text"
                      style={{width: 120}}
                      defaultDate={new Date(this.props.tracker.values.participants[index].routineGroupEndDate)}
                      name={"participants.["+index+"].routineGroupEndDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].routineGroupEndDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].routineGroupEndDate !== 'undefined' ?
                              this.props.tracker.values.participants[index].routineGroupEndDate !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].routineGroupEndDate")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                } else {
                  routineGroupEndDate = <div>
                    <Field
                      className={
                        typeof this.props.tracker !== 'undefined' ?
                          typeof this.props.tracker.values !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                              typeof this.props.tracker.values.participants[index].routineGroupEndDate !== 'undefined' ?
                                this.props.tracker.values.participants[index].routineGroupEndDate === null ? 'deleted dateInput'
                                : 'ac dateInput'
                              : 'ac dateInput'
                            : 'ac dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      }
                      component={renderDatePicker}
                      label="gyakorló csoport befejezés"
                      floatingLabelText="gyakorló csoport befejezés"
                      hintText="gyakorló csoport befejezés"
                      type="text"
                      style={{width: 120}}
                      name={"participants.["+index+"].routineGroupEndDate"} />
                    <Field
                      component={renderTextField}
                      className="dateText"
                      floatingLabelText=""
                      name={"participants.["+index+"].routineGroupEndDate"}
                      type="text"
                    />
                    {
                      typeof this.props.tracker !== 'undefined' ?
                        typeof this.props.tracker.values !== 'undefined' ?
                          typeof this.props.tracker.values.participants[index] !== 'undefined' ?
                            typeof this.props.tracker.values.participants[index].routineGroupEndDate !== 'undefined' ?
                              this.props.tracker.values.participants[index].routineGroupEndDate !== null ? (<div className="">
                                  <IconButton onClick={this.delete("participants.["+index+"].routineGroupEndDate")} className="deleteIcon">
                                    <ContentClear />
                                  </IconButton>
                                </div>)
                              : void(0)
                            :void (0)
                          : void(0)
                        : void(0)
                      : void(0)
                    }
                  </div>
                }
                if (modules.indexOf('vezető képzés') /*.includes('vezető képzés')*/) {
                  let link;
                  if (typeof this.props.groupinfos.participants !== 'undefined') {
                    if (typeof this.props.groupinfos.participants[index] !== 'undefined') {
                      if (typeof this.props.groupinfos.participants[index].leaderPartner !== 'undefined') {
                        link = <IconButton
                              iconStyle={styles.smallIcon}
                              style={styles.m15}
                              href={"/persons/"+this.props.groupinfos.participants[index].leaderPartner.id} target="_blank"
                            >
                              <ActionLaunch />
                            </IconButton>
                      }
                    }
                  }
                  vezeto = <Paper zDepth={1}>
                    <label>Vezető képzés modul</label>
                    <br />
                    <div className='flexContainer'>
                      <div>
                        <div>
                          <div className="horizontal flexrow">
                            {link}
                            <Field
                              className={"itsAWeirdAnInput"}
                              disabled={true}
                              component={renderTextField}
                              label="vezető társ"
                              name={"participants.["+index+"].leaderPartner.name"}
                              style={{width: 180}}
                            >
                            </Field>
                            <IconButton
                              iconStyle={styles.smallIcon}
                              style={styles.m15}
                              onMouseDown={this.delete("participants.["+index+"].leaderPartner.name")}
                            >
                              <ActionDelete />
                            </IconButton>
                          </div>
                          <Field
                            className="personAutocomplete plusItem"
                            component={renderAutoComplete}
                            label="Új vezető társ"
                            name={"participants.["+index+"].newLeaderPartner.name"}
                            dataSource={datasource}
                            dataSourceConfig={dataSourceConfig}
                            onNewRequest={this.handleParticipantsLeaderPartner}
                          >
                          </Field>
                          <Field
                            component={renderTextField}
                            type="text"
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            label="id"
                            name={"participants.["+index+"].leaderPartner.id"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="email"
                            name={"participants.["+index+"].leaderPartner.email"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="birthday"
                            name={"participants.["+index+"].leaderPartner.birthday"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="TBNumber"
                            name={"participants.["+index+"].leaderPartner.tbNumber"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="indexNumber"
                            name={"participants.["+index+"].leaderPartner.indexNumber"}
                          >
                          </Field>
                        </div>
                        <Field
                          component={renderTextField}
                          floatingLabelText="egyéni szupervízió óraszáma"
                          name={"participants.["+index+"].supervisionLessonCount"}
                          type="text"/>
                        <div>
                          <div className="horizontal flexrow">
                            {
                              typeof this.props.groupinfos.participants !== 'undefined' ?
                                typeof this.props.groupinfos.participants[index] !== 'undefined' ?
                                  typeof this.props.groupinfos.participants[index].supervisor !== 'undefined' ?
                                    <IconButton
                                        iconStyle={styles.smallIcon}
                                        style={styles.m15}
                                        href={"/persons/"+this.props.groupinfos.participants[index].supervisor.id} target="_blank"
                                      >
                                        <ActionLaunch />
                                      </IconButton>
                                  : void(0)
                                : void(0)
                              : void(0)
                            }
                            <Field
                              className={"itsAWeirdAnInput"}
                              disabled={true}
                              component={renderTextField}
                              label="szupervízor"
                              name={"participants.["+index+"].supervisor.name"}
                              style={{width: 180}}
                            >
                            </Field>
                            <IconButton
                              iconStyle={styles.smallIcon}
                              style={styles.m15}
                              onMouseDown={this.delete("participants.["+index+"].supervisor.name")}
                            >
                              <ActionDelete />
                            </IconButton>
                          </div>
                          <Field
                            className="personAutocomplete plusItem"
                            component={renderAutoComplete}
                            label="Új szupervízor"
                            name={"participants.["+index+"].newSupervisor.name"}
                            dataSource={datasource}
                            dataSourceConfig={dataSourceConfig}
                            onNewRequest={this.handleParticipantsSupervisor}
                          >
                          </Field>
                          <Field
                            component={renderTextField}
                            type="text"
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            label="id"
                            name={"participants.["+index+"].supervisor.id"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="email"
                            name={"participants.["+index+"].supervisor.email"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="birthday"
                            name={"participants.["+index+"].supervisor.birthday"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="TBNumber"
                            name={"participants.["+index+"].supervisor.tbNumber"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="indexNumber"
                            name={"participants.["+index+"].supervisor.indexNumber"}
                          >
                          </Field>
                        </div>
                        <Field
                          component={renderTextField}
                          floatingLabelText="csoportos szupervízió óraszáma"
                          name={"participants.["+index+"].groupSupervisionLessonCount"}
                          type="text"/>
                        <div>
                          <div className="horizontal flexrow">
                            {
                              typeof this.props.groupinfos.participants !== 'undefined' ?
                                typeof this.props.groupinfos.participants[index] !== 'undefined' ?
                                  typeof this.props.groupinfos.participants[index].groupSupervisor !== 'undefined' ?
                                    <IconButton
                                        iconStyle={styles.smallIcon}
                                        style={styles.m15}
                                        href={"/persons/"+this.props.groupinfos.participants[index].groupSupervisor.id} target="_blank"
                                      >
                                        <ActionLaunch />
                                      </IconButton>
                                  : void(0)
                                : void(0)
                              : void(0)
                            }
                            <Field
                              className={"itsAWeirdAnInput"}
                              disabled={true}
                              component={renderTextField}
                              label="csoportos szupervízor"
                              name={"participants.["+index+"].groupSupervisor.name"}
                              style={{width: 180}}
                            >
                            </Field>
                            <IconButton
                              iconStyle={styles.smallIcon}
                              style={styles.m15}
                              onMouseDown={this.delete("participants.["+index+"].groupSupervisor.name")}
                            >
                              <ActionDelete />
                            </IconButton>
                          </div>
                          <Field
                            className="personAutocomplete plusItem"
                            component={renderAutoComplete}
                            label="Új csoportos szupervízor"
                            name={"participants.["+index+"].newGroupSupervisor.name"}
                            dataSource={datasource}
                            dataSourceConfig={dataSourceConfig}
                            onNewRequest={this.handleParticipantsGroupSupervisor}
                          >
                          </Field>
                          <Field
                            component={renderTextField}
                            type="text"
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            label="id"
                            name={"participants.["+index+"].groupSupervisor.id"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="email"
                            name={"participants.["+index+"].groupSupervisor.email"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="birthday"
                            name={"participants.["+index+"].groupSupervisor.birthday"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="TBNumber"
                            name={"participants.["+index+"].groupSupervisor.tbNumber"}
                          >
                          </Field>
                          <Field
                            className="hidden"
                            style={{
                              display: 'none'
                            }}
                            component={renderTextField}
                            type="text"
                            label="indexNumber"
                            name={"participants.["+index+"].groupSupervisor.indexNumber"}
                          >
                          </Field>
                        </div>
                      </div>
                      <div>
                        {routineGroupStartDate}
                        {routineGroupEndDate}
                        <Field
                          component={renderTextField}
                          floatingLabelText="gyakorló csoport óraszám"
                          name={"participants.["+index+"].routineGroupLessonCount"}
                          type="text"/>
                        <Field
                          component={renderTextField}
                          floatingLabelText="gyakorló csoport leírás"
                          name={"participants.["+index+"].routineGroupLessonDescription"}
                          type="text"/>
                      </div>
                    </div>
                  </Paper>
                }
              // workshop modul
                let workshop;
                if (modules.indexOf('workshop') > -1/*.includes('workshop') - IE11 error */) {
                  workshop = <Paper zDepth={1}>
                    <label>Workshop modul</label>
                    <br />
                    <Field
                      component={renderCheckbox}
                      label="workshopok"
                      name={"participants.["+index+"].hasWorkshop"}
                      style={styles.checkbox}
                    />
                    <Field
                      component={renderTextField}
                      floatingLabelText="workshop megjegyzés"
                      name={"participants.["+index+"].workshopComment"}
                      type="text"/>
                  </Paper>
                }
              return <Card
                  key={index}
                  className={option.name === false ? 'hidden' : 'shw'}>
                <CardHeader
                  title={
                    <div className="horizontal">
                      <div>
                        <a href={"/persons/"+option.id} target="_blank">{option.name}</a>
                      </div>
                      <IconButton
                        iconStyle={styles.smallIcon}
                        style={{marginLeft: 15, padding: 0, width: 24, height: 24}}
                        href={"/persons/"+option.id} target="_blank"
                      >
                        <ActionLaunch />
                      </IconButton>
                    </div>
                  }
                  subtitle={
                    <small style={{color: lightBlack}}>
                      {email}
                      {birthday}
                    </small>
                  }
                  actAsExpander={true}
                  showExpandableButton={true}
                />
                <CardText expandable={true}>
                  <div className='flexContainer pt40'>
                    <div className='fullAbsolute'>
                      <span className='beforeButton'>
                        {option.name} törlése a résztvevők közül: 
                      </span>
                      <IconButton
                        iconStyle={styles.smallIcon}
                        style={{marginLeft: 0, padding: 0, width: 24, height: 24}}
                        onTouchTap={this.removeParticipant(option.id)}
                      >
                        <ActionDelete />
                      </IconButton>
                    </div>
                    {regFee}
                    {kepzesi}
                    {vizsga}
                    {tanusitvany}
                    {vezeto}
                    {workshop}
                  </div>
                </CardText>
              </Card>
            })
          }
        </div>
      }
    }
  }

  /**
    * Helper for group registration fee reequest
    * 
  **/
  getGroupRegFee() {
    if (typeof this.props.groupinfos !== "undefined" && typeof this.props.groupregistrationfee === "undefined" ) {
      if (dontHaveGroupRegFee) {
        dontHaveGroupRegFee = false;
        if (this.props.groupinfos.positionNumber !== '') {
          this.props.openGroupregistrationfee('/groups', '/'+this.props.groupinfos.id+'/group-registration-fee', '');
        }
      }
    }
  }

  renderGroupRegistrationFee() {
      let defaultDate = null;
      if (typeof this.props.groupinfos.groupRegistrationFee !== "undefined") {
        if (typeof this.props.groupinfos.groupRegistrationFee.paymentDate !== "undefined") {
          return <Paper zDepth={1}>
            <label>Csoportregisztrációs díj:</label>
            <br />
            <Field
              component={renderTextField}
              floatingLabelText="fizetendő összeg (Ft)"
              name="groupRegistrationFee.amount"
              type="text"/>
            <Field
              component={renderTextField}
              floatingLabelText="fizetve (Ft)"
              name="groupRegistrationFee.payed"
              type="text"/>
            <Field
              className={
                typeof this.props.tracker !== 'undefined' ?
                  typeof this.props.tracker.values !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                      typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                        this.props.tracker.values.groupRegistrationFee.paymentDate === null ? 'deleted dateInput'
                        : 'ac dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              }
              component={renderDatePicker}
              label="Befizetés dátuma."
              floatingLabelText="Befizetés dátuma."
              hintText="Befizetés dátuma."
              type="text"
              style={{width: 120}}
              defaultDate={new Date(this.props.groupinfos.groupRegistrationFee.paymentDate)}
              name="groupRegistrationFee.paymentDate" />
            <Field
              component={renderTextField}
              className="dateText"
              floatingLabelText=""
              name="groupRegistrationFee.paymentDate"
              type="text"
            />
            {
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                      this.props.tracker.values.groupRegistrationFee.paymentDate !== null ? (<div className="">
                          <IconButton onClick={this.delete("groupRegistrationFee.paymentDate")} className="deleteIcon">
                            <ContentClear />
                          </IconButton>
                        </div>)
                      : void(0)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            }
            <Field
              component={renderTextField}
              floatingLabelText="számla száma"
              name="groupRegistrationFee.invoiceNumber"
              type="text"/>
          </Paper>
        } else {
          return <Paper zDepth={1}>
            <label>Csoportregisztrációs díj:</label>
            <br />
            <Field
              component={renderTextField}
              floatingLabelText="fizetendő összeg (Ft)"
              name="groupRegistrationFee.amount"
              type="text"/>
            <Field
              component={renderTextField}
              floatingLabelText="fizetve (Ft)"
              name="groupRegistrationFee.payed"
              type="text"/>
            <Field
              className={
                typeof this.props.tracker !== 'undefined' ?
                  typeof this.props.tracker.values !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                      typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                        this.props.tracker.values.groupRegistrationFee.paymentDate === null ? 'deleted dateInput'
                        : 'ac dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              }
              component={renderDatePicker}
              label="Befizetés dátuma."
              floatingLabelText="Befizetés dátuma."
              hintText="Befizetés dátuma."
              type="text"
              style={{width: 120}}
              name="groupRegistrationFee.paymentDate" />
            <Field
              component={renderTextField}
              className="dateText"
              floatingLabelText=""
              name="groupRegistrationFee.paymentDate"
              type="text"
            />
            {
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                      this.props.tracker.values.groupRegistrationFee.paymentDate !== null ? (<div className="">
                          <IconButton onClick={this.delete("groupRegistrationFee.paymentDate")} className="deleteIcon">
                            <ContentClear />
                          </IconButton>
                        </div>)
                      : void(0)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            }
            <Field
              component={renderTextField}
              floatingLabelText="számla száma"
              name="groupRegistrationFee.invoiceNumber"
              type="text"/>
          </Paper>
        }
      } else {
        return <Paper zDepth={1}>
          <label>Csoportregisztrációs díj:</label>
          <br />
          <Field
            component={renderTextField}
            floatingLabelText="fizetendő összeg (Ft)"
            name="groupRegistrationFee.amount"
            type="text"/>
          <Field
            component={renderTextField}
            floatingLabelText="fizetve (Ft)"
            name="groupRegistrationFee.payed"
            type="text"/>
          <Field
            className={
              typeof this.props.tracker !== 'undefined' ?
                typeof this.props.tracker.values !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                    typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                      this.props.tracker.values.groupRegistrationFee.paymentDate === null ? 'deleted dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                  : 'ac dateInput'
                : 'ac dateInput'
              : 'ac dateInput'
            }
            component={renderDatePicker}
            label="Befizetés dátuma."
            floatingLabelText="Befizetés dátuma."
            hintText="Befizetés dátuma."
            type="text"
            style={{width: 120}}
            name="groupRegistrationFee.paymentDate" />
          <Field
            component={renderTextField}
            className="dateText"
            floatingLabelText=""
            name="groupRegistrationFee.paymentDate"
            type="text"
          />
          {
            typeof this.props.tracker !== 'undefined' ?
              typeof this.props.tracker.values !== 'undefined' ?
                typeof this.props.tracker.values.groupRegistrationFee !== 'undefined' ?
                  typeof this.props.tracker.values.groupRegistrationFee.paymentDate !== 'undefined' ?
                    this.props.tracker.values.groupRegistrationFee.paymentDate !== null ? (<div className="">
                        <IconButton onClick={this.delete("groupRegistrationFee.paymentDate")} className="deleteIcon">
                          <ContentClear />
                        </IconButton>
                      </div>)
                    : void(0)
                  : void(0)
                : void(0)
              : void(0)
            : void(0)
          }
          <Field
            component={renderTextField}
            floatingLabelText="számla száma"
            name="groupRegistrationFee.invoiceNumber"
            type="text"/>
        </Paper>
      }
  }

  delete (text) {
    return () => {
        this.props.change(text, null)
      //this.props.onSubmit(this.refs.user.getValue(), this.refs.password.getValue())
    }
  }

  removeParticipant (id) {
    return () => {
      let signedToRemove;
      this.props.tracker.values.participants.map((option, index) => {
        if (option.id == id) {
          signedToRemove = index;
        }
      })
      console.log(signedToRemove)
      this.props.tracker.values.participants[signedToRemove].remove
      this.props.change('participants.['+signedToRemove+'].name', false)
      //this.props.onSubmit(this.refs.user.getValue(), this.refs.password.getValue())
    }
  }

  render() {
    if(typeof this.props.groupinfos !== 'undefined' && typeof this.props.grouptypes !== 'undefined' && typeof this.props.trainingstatus !== "undefined") {
      const {handleSubmit} = this.props
      this.getGroupRegFee()
      return (
        <div>
            {this.renderAlert()}
            <form onSubmit={handleSubmit} style={styles.pt15} className='formFormat' >
              <div className="full">
                <Field
                  component={renderTextField}
                  floatingLabelText="pozíció szám"
                  name="positionNumber"
                  style={{
                    display: "inline-block",
                    maxWidth: 320
                  }}
                  type="text"/>
              </div>
              <div className='flexContainer' style={{paddingTop: 60}}>
                <Paper zDepth={1}>
                  <label>Csoport adatok:</label>
                  <br />
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="id"
                    type="hidden"
                  />

                  <Field
                    component={renderSelectField}
                    floatingLabelText={"típus:"}
                    name={"type"}
                  >
                    {
                      this.props.grouptypes.map((option, index) => {
                        if (option.value.indexOf('önismereti') === -1/* !option.value.includes("önismereti") - IE11 */) {
                          return <MenuItem key={index} value={option.value} primaryText={option.value} />
                        }
                      })
                    }
                  </Field>
                  {this.renderStartDate()}
                  {this.renderEndDate()}
                  <Field
                    component={renderTextField}
                    floatingLabelText="óraszám"
                    name="lessonCount"
                    type="text"/>
                </Paper>
                <Paper zDepth={1}>
                  <label>Vezetők:</label>
                  <br />
                  {this.renderBase('leaders')}
                  {this.renderBase('groupSupervisor')}
                </Paper>
                <Paper zDepth={1}>
                  <label>Egyéb adatok:</label>
                  <br />
                  <Field
                    component={renderTextField}
                    floatingLabelText="Helyszín"
                    name="location"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="Létszám"
                    name="participantCount"
                    type="text"/>
                  <Field
                    component={renderTextField}
                    floatingLabelText="Képzési díj"
                    name="registrationFee"
                    type="text"/>
                  <br />
                  <Field
                    component={renderCheckbox}
                    label="jegyzőkönyv leadva"
                    name="recordDelivered"
                    style={styles.checkbox}
                  />
                  <br />
                  {this.renderExam()}
                </Paper>

                <Paper zDepth={1}>
                  <label>Megjegyzések:</label>
                  <br />
                  {
                    this.props.groupinfos.comments.map((option, index) => {
                      if (option !== null && option.text !== null) {
                        return <div key={index} className={this.props.tracker.values.comments[index].text === null ? 'hidden horizontal' : 'shw horizontal'}>
                          <Field
                            className='itsAWeirdAnInput'
                            component={renderTextField}
                            floatingLabelText={"megjegyzés ("+option.time.substring(0,10)+")"}
                            name={"comments.["+index+"].text"}
                            multiLine={true}
                            disabled={true}
                            rows={1}
                            rowsMax={4}
                            type="text"
                          />
                          <IconButton
                            iconStyle={styles.smallIcon}
                            style={styles.small}
                            onMouseDown={this.delete("comments.["+index+"].text")}
                          >
                            <ActionDelete />
                          </IconButton>
                        </div>
                      }
                    })
                  }
                  <div className="horizontal">
                    <Field
                      component={renderTextField}
                      floatingLabelText="új megjegyzés"
                      hintText="új megjegyzés"
                      type="text"
                      multiLine={true}
                      rows={1}
                      rowsMax={4}
                      name="commentsnew.text" />
                  </div>
                </Paper>
                {this.renderGroupRegistrationFee()}
              </div>
              <Paper  zDepth={1} className='w100 p15 fullWidth' style={this.props.groupinfos.isSaved ? {} : {display : 'none'}} >
                <div>
                <label>Résztvevők:</label>
                <br />
                {this.renderBase('participants')}
                </div>
              </Paper>

              <div style={{display: 'none'}}>
                <Paper  zDepth={1} className='flexEnd p15'>
                  <RaisedButton className="TgroupFormSubmitButton" type="submit" label="mentés" primary={true} labelColor={'#FFFFFF'}/>
                </Paper>
              </div>
            </form>
        </div>
      )
    } else {
      return (
        <div>
            {this.renderAlert()}
            <form>
              <div>.
              </div>
            </form>
        </div>
      )
    }
  }
}

const validate = values => {
  const errors = {}

  if (values.password !== values.passwordConfirmation) {
    errors.password = 'Passwords must match'
  }
    /*
  if (!values.email) {
    errors.email = 'Please enter an email'
  }
    */
  if (!values.password) {
    errors.password = 'Please enter a password'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Please confirm your password'
  }

  return errors
}

TgroupForm = reduxForm({
  form: 'tgroup',
  validate
})(TgroupForm)

// You have to connect() to any reducers that you wish to connect to yourself
TgroupForm = connect(
  state => ({
    initialValues: typeof state.groups.thisgroup !== 'undefined' ? state.groups.thisgroup.type !== 'unset' ? state.groups.thisgroup : {'id' : state.groups.thisgroup.id, 'type' : "pszichodráma asszisztensi"} : state.groups.thisgroup, // pull initial values from reducer
    enableReinitialize : true
  })//,
  //{ load: loadAccount }               // bind account loading action creator
)(TgroupForm)

export default TgroupForm


// WEBPACK FOOTER //
// ./src/components/traininggroups/tgroup_form.js